module.exports = __webpack_public_path__ + "img/blueTestCase.0ad678f9.svg";